// @flow
import main from './src/sagas/main'

export default main
